




























































































import Vue from "vue";
import TableRow from "./TableRow.vue";
import Search from "@/components/Search.vue";
import VirtualTable from "@/components/table/VirtualTable.vue";
import { onMounted, ref, computed, onBeforeUnmount } from "@vue/composition-api";
import * as state from "./data/state";
import { tableConfig } from "./table.config";
import { EventBus } from "@/eventbus";
import { emptyFn } from "@/fp";
import { AdminUser, UserStatus, UserRole } from "./data/models";
import { UseModal } from "@/components/root/modal";
import InviteAdminModal from "./invite-modal/index.vue";
import AuditLogModalVue from "./AuditLogModal.vue";
import { SortBy } from "@/common/models";
import { SharedState } from "@/common/state";
import { ToastType, UseToast } from "@/components/root/toast/toast.state";
import { AppAnalytics } from "@/analytics";
import { UseDrillDownMenu } from "@/components/root/drilldown-menu/drilldown-menu.state";
import ScopeModalVue from "./ScopeModal.vue";
import ChangeRoleModalVue from "./ChangeRoleModal.vue";
import { Restriction } from "@/common/models/admin-restrictions.model";
import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import AdminGridItem from "./AdminGridItem.vue";
export default Vue.extend({
  components: {
    VirtualTable,
    Search,
    PageWithMainContainer,
    AdminGridItem,
  },
  setup(_, { root: { $router } }) {
    const {
      display_as_table,
      set_display_as_table,
      isLoading,
      getAdmins,
      admins,
      totalCount,
      isPerformingAction,
      changeStatus,
      onSortingChanged,
      update_admin_restrictions,
    } = state;

    onMounted(() =>
      SharedState.onReady(() => {
        const { show } = $router.currentRoute.query;
        if (show && show === "invite") {
          inviteAdmins();
        }
        if (SharedState.isDemo.value) {
          $router.replace({ path: "/" });
        }
        if (admins.value.length === 0) {
          getAdmins();
        }
      })
    );

    const query = ref("");
    const noResults = computed(
      () => displayList.value.length === 0 && !isLoading.value
    );
    const isSearching = computed(() => query.value.length > 0);

    const displayList = computed(() => {
      const _query = query.value.toLowerCase();
      return isSearching.value
        ? admins.value.filter(
            (a) =>
              a.email.toLowerCase().search(_query) > -1 &&
              a.status != UserStatus.BLOCKED
          )
        : admins.value.filter((a) => a.status != UserStatus.BLOCKED);
    });

    /**
     * Gated on `admin_audit`. The export is only meaningful to someone who can
     * see the admin list in the first place, so it rides in this header.
     */
    const has_admin_audit = computed(() =>
      SharedState.FeatureHelper.is_enabled("admin_audit")
    );

    const open_audit_log = async () => {
      const res = await UseModal().show(AuditLogModalVue, {});
      if (res.type === "success" && res.msg) {
        /*
         * UI only: the range is validated and handed back here. Fetching the
         * log and building the CSV is a separate task, so there is no file to
         * produce yet — but the button must still answer the click. Without
         * this the dialog just closed and nothing happened, which reads as a
         * broken control rather than an unfinished one.
         */
        const { from, to } = (res.msg as unknown) as {
          from: string;
          to: string;
        };
        UseToast().show({
          type: ToastType.INFO,
          msg: `Audit log export requested for ${from} to ${to}. Download will be available once the export service is connected.`,
          duration: 6000,
        });
      }
    };

    const inviteAdmins = async () => {
      AppAnalytics.report({
        component: "Settings",
        eventName: "Settings_Cognni admins_invite admin",
      });
      await UseModal().show(InviteAdminModal, "bubu");
    };

    const change_role = async (user: AdminUser) => {
      const res = await UseModal().show(ChangeRoleModalVue, user);
      if (res.type === "success") {
        console.log("change_response : ", res.msg);
        // @ts-ignore
        const restrictions = res.msg.restrictions;
        // @ts-ignore
        const role = res.msg.role;
        console.log(user);
        update_admin_restrictions({
          admin: user,
          restrictions,
          role,
        });
      }
    };

    const show_menu_from_grid_item = (payload: any) => {
      EventBus.emit("showMenu", { ...payload, from_card: true });
    };

    const subscrptions = {
      changeStatus: emptyFn(),
      onShowMenu: emptyFn(),
    };

    onMounted(() => {
      subscrptions.changeStatus = EventBus.listen(
        "change-status",
        (admin: AdminUser) => {
          AppAnalytics.report({
            component: "Settings",
            eventName: `Settings_Cognni admins_active/block ${
              admin.status === UserStatus.BLOCKED ? "active" : "block"
            } admin`,
          });
          changeStatus(admin);
        }
      );

      EventBus.listen(
        "showMenu",
        async (p: {
          user: AdminUser;
          event: MouseEvent;
          from_card: boolean;
        }) => {
          const side = p.from_card ? "left" : "right";
          const res = await UseDrillDownMenu().show({
            side,
            menu: [
              {
                name: "Remove Admin",
                icon: "Trash",
                isCategory: false,
                subItems: [],
                isPremium: false,
                disable: false,
                action: "block",
              },
              {
                name: "Change Role",
                icon: "User",
                isCategory: false,
                subItems: [],
                isPremium: false,
                disable: false,
                action: "change-role",
              },
              ...(p.user.role === UserRole.SYSTEM_ADMIN
                ? []
                : [
                    {
                      name: "Modify Permissions",
                      icon: "EditBoard",
                      isCategory: false,
                      subItems: [],
                      isPremium: false,
                      disable: false,
                      action: "modify-permissions",
                    },
                  ]),
            ],
            event: p.event,
          });

          if (res.didUserSelectedAnAction) {
            switch (res.actionSelected) {
              case "block":
                AppAnalytics.report({
                  component: "Settings",
                  eventName: `Settings_Cognni admins_active/block ${
                    p.user.status === UserStatus.BLOCKED ? "active" : "block"
                  } admin`,
                });
                changeStatus(p.user);
                break;
              case "change-role":
                change_role(p.user);
                break;
              case "modify-permissions":
                {
                  const res = await UseModal().show(ScopeModalVue, p.user);
                  if (res.type === "success") {
                    // @ts-ignore
                    const restrictions: Restriction[] = res.msg;
                    update_admin_restrictions({
                      admin: p.user,
                      restrictions,
                      role: UserRole.BUSINESS_ADMIN,
                    });
                  }
                }
                break;
              default:
                break;
            }
          }
        }
      );
    });

    onBeforeUnmount(() =>
      Object.values(subscrptions).forEach((unsub) => unsub())
    );

    const onTableSort = (sortBy: SortBy) => {
      AppAnalytics.report({
        component: "Settings",
        eventName: "Settings_Cognni admins_sort by " + sortBy.key,
      });
      // set the current active 'sort by' column.
      tableConfig.value = {
        columns: tableConfig.value.columns.map((col) => {
          if (col.key === sortBy.key) {
            col.sortDir = sortBy.dir;
            col.isSortActive = true;
          } else {
            col.isSortActive = false;
          }
          return col;
        }),
      };
      // apply sorting.
      onSortingChanged(sortBy);
    };

    const onShowSearch = () => {
      AppAnalytics.report({
        component: "Settings",
        eventName: "Settings_Cognni admins_search_click on search icon",
      });
    };

    return {
      has_admin_audit,
      open_audit_log,
      display_as_table,
      set_display_as_table,
      is_sys_user: SharedState.is_sys_user,
      TableRow,
      isLoading,
      tableConfig,
      displayList,
      admins,
      noResults,
      totalCount,
      query,
      isPerformingAction,
      inviteAdmins,
      onTableSort,
      onShowSearch,
      change_role,
      show_menu_from_grid_item,
    };
  },
});
